// One public catalog reader. The challenge gateway owns its result and passes
// it to registration; standalone consumers may make their own fresh read.
//
// Reads started in the same synchronous run share one request. React
// StrictMode mounts, unmounts and remounts every effect in one pass in
// development, so the /challenges gateway used to ask for the same catalog
// twice at once. The shared read is forgotten at the next microtask, so any
// later read or retry, even one that starts while an earlier request is still
// hanging, always goes to the API fresh.
const inflight = new Map();

const fetchPublicChallengeCatalog = async (apiUrl) => {
  const response = await fetch(
    `${apiUrl}/courses/session-groups?active=true&registrationAccess=public&limit=50`,
  );
  if (!response.ok) throw new Error(`session_groups_${response.status}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.sessionGroups || data.data || [];
};

export const readPublicChallengeCatalog = (apiUrl) => {
  const pending = inflight.get(apiUrl);
  if (pending) return pending;
  const forget = () => {
    if (inflight.get(apiUrl) === read) inflight.delete(apiUrl);
  };
  const read = fetchPublicChallengeCatalog(apiUrl);
  inflight.set(apiUrl, read);
  queueMicrotask(forget);
  return read;
};
